import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux'; 
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import Dashboard from './routes/dashboard';
import Store from './routes/store'; 
import Profile from './routes/profile'; 
import Auth from './routes/login';           
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import './static/css/newStyle.css';
import GlobalStyle from './styles/globalStyle';

const { theme } = config;

const AppRoutes = () => {


    const isLoggedIn = useSelector((state) => state.auth.login);

    const rtl = false;
    const topMenu = true;
    const darkMode = false;
    // const location = useLocation();

    // console.log('location',location)

    const [, setLocationAllowed] = useState(false);
    const [, setError] = useState("");

    useEffect(() => {
        let isMounted = true;

        const requestLocationIOSSafe = (retries = 2) => {
            return new Promise((resolve) => {
                if (!navigator.geolocation) {
                    resolve({ status: "NOT_SUPPORTED" });
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            status: "OK",
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        });
                    },
                    (error) => {
                        console.warn(`Geolocation error (code ${error.code}): ${error.message}`);
                        if (error.code === error.PERMISSION_DENIED) {
                            resolve({ status: "PERMISSION_DENIED" });
                            return;
                        }
                        if (retries > 0) {
                            setTimeout(() => {
                                requestLocationIOSSafe(retries - 1).then(resolve);
                            }, 2000);
                        } else {
                            resolve({ status: "POSITION_UNAVAILABLE" });
                        }
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 2000,
                        maximumAge: 0,
                    }
                );
            });
        };

        requestLocationIOSSafe().then((res) => {
            if (!isMounted) return;

            if (res.status === "OK") {
                console.log("Location OK:", res);
                setLocationAllowed(true);
                setError("");
                return;
            }

            if (res.status === "PERMISSION_DENIED") {
                setError( "Location access is required. Please enable location permission and reload." );
                return;
            }

            if (res.status === "NOT_SUPPORTED") {
                setError("Geolocation is not supported by this browser.");
                return;
            }

            setError( "Unable to detect location. Please move to an open area and try again." );
        });

        return () => {
            isMounted = false;
        };
    }, []);


    // /* ❌ BLOCK APP */
    // if (!locationAllowed) {
    //     return (
    //         <div style={{ textAlign: "center", marginTop: "100px" }}>
    //             <h2>Location Permission Required</h2>
    //             <p>{error}</p>
    //             <button onClick={requestLocationIOSSafe}>
    //                 Allow Location
    //             </button>
    //         </div>
    //     );
    // }

    return (
        <ConfigProvider direction={rtl ? 'rtl' : 'ltr'} theme={{
            token: {
              fontFamily: 'Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            },
          }}>
            <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
                <GlobalStyle />
                <Routes>
                    <Route path="/login" element={!isLoggedIn ? <Auth /> : <Navigate to="/dashboard" replace />} />

                    <Route element={<ProtectedRoute />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/store/*" element={<Store />} />
                        <Route path="/profile/*" element={<Profile />} />
                        {/* other protected routes */}
                    </Route>

                    <Route path="*" element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />} />
                </Routes>
            </ThemeProvider>
        </ConfigProvider>
    );
};

const App = () => (
    <>
        <Provider store={store}>
            <Router basename={process.env.PUBLIC_URL}>
                <AppRoutes />
            </Router>
        </Provider>
    </>
);

export default App;
